import Axios from "../../../../api/axios/Axios";

const enc = (value) => encodeURIComponent(String(value ?? "").trim());

const groupUrl = (groupTag) => {
  const tag = String(groupTag ?? "").trim();

  if (!tag) {
    throw new Error("Group tag is required.");
  }

  return `/api/groups/${enc(tag)}`;
};

const normalizeStatus = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const normalizeGroup = (item) => {
  if (!item) return null;

  const isOwner = item.isOwner === true || Number(item.isOwner) === 1;

  const memberStatus = isOwner
    ? "approved"
    : normalizeStatus(
        item.memberStatus ?? item.membershipStatus ?? item.status,
      );

  return {
    ...item,
    isOwner,
    memberStatus,
    status: memberStatus,
  };
};

const extractGroups = (data) => {
  if (Array.isArray(data)) return data;

  if (Array.isArray(data?.groups)) return data.groups;

  if (Array.isArray(data?.memberships)) {
    return data.memberships;
  }

  if (Array.isArray(data?.data)) return data.data;

  if (Array.isArray(data?.data?.groups)) {
    return data.data.groups;
  }

  return [];
};

export const findGroupCode = (groupCode) =>
  Axios.get(`/api/groups/code/${enc(groupCode)}`);

export const getMemberGroups = async () => {
  const response = await Axios.get("/api/groups/mine");

  const groups = extractGroups(response.data)
    .map(normalizeGroup)
    .filter(Boolean);

  return {
    ...response,
    data: groups,
  };
};

export const getMemberGroup = async (groupTag) => {
  const response = await Axios.get(groupUrl(groupTag));

  const data = response.data;

  return {
    ...response,
    data: normalizeGroup(data?.group ?? data),
  };
};

export const joinGroup = (groupTag, data) =>
  Axios.post(`${groupUrl(groupTag)}/join`, data);

export const leaveMemberGroup = (groupTag) =>
  Axios.delete(`${groupUrl(groupTag)}/leave`);

export const getApprovedGroupMemberships = ({
  groupTag,
  limit = 50,
  offset = 0,
}) =>
  Axios.get(`${groupUrl(groupTag)}/members/approved`, {
    params: { limit, offset },
  });

export const getApprovedGroupMembershipsCount = (groupTag) =>
  Axios.get(`${groupUrl(groupTag)}/members/count`);

export const updateMemberGroupMembership = (groupTag, data) =>
  Axios.put(`${groupUrl(groupTag)}/membership`, data);

export const updateMemberGroupLastViewed = (groupTag) =>
  Axios.put(`${groupUrl(groupTag)}/last-viewed`);

export const checkMemberGroupUpdates = () =>
  Axios.get("/api/groups/check-updates");
